export default {
  confirmationInfo:
    'Your unsaved edits on the previous call will be lost, are you sure you want to work on the new call?',
  log: 'Log',
  save: 'Save & Work on New',
  discard: 'Discard & Work on New',
  stay: 'Stay on Previous Work',
} as const;
